const body = document.body;
const header = document.querySelector('.heading');
const scrollTopButton = document.querySelector('#scrollup');
let scrollFrame = null;
const compactAt = 100;
const expandAt = 50;

function updateStickyHeader() {
  scrollFrame = null;
  const isCompact = body.classList.contains('np-header-compact');

  if (!isCompact && window.scrollY >= compactAt) {
    body.classList.add('np-header-compact');
  } else if (isCompact && window.scrollY <= expandAt) {
    body.classList.remove('np-header-compact');
  }
}

if (header) {
  updateStickyHeader();
  window.addEventListener('scroll', () => {
    if (scrollFrame === null) scrollFrame = window.requestAnimationFrame(updateStickyHeader);
  }, { passive: true });
}

scrollTopButton?.addEventListener('click', () => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
});
